export function slugify(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

// Expect pattern <slug>-<id>; returns id number or null
export function extractIdFromSlug(slug?: string | null): number | null {
  if (!slug) return null;
  const match = slug.match(/-(\d+)$/);
  if (match) return Number(match[1]);
  const numeric = Number(slug);
  return isNaN(numeric) ? null : numeric;
}